'use es6';

export var maybeEarlyRequest = function maybeEarlyRequest(requestName, requestCb) {
  var earlyRequest = requestName && window.quickFetch && window.quickFetch.getRequestStateByName(requestName);

  if (earlyRequest) {
    var earlyRequestPromise = new Promise(function (resolve, reject) {
      earlyRequest.whenFinished(function (result) {
        resolve(result);
        window.quickFetch.removeEarlyRequest(requestName);
      });
      earlyRequest.onError(function () {
        // retry the request
        requestCb().then(resolve).catch(function (err) {
          reject(err);
        });
        window.quickFetch.removeEarlyRequest(requestName);
      });
    });

    if (window.newrelic) {
      window.newrelic.setCustomAttribute(requestName + "-early-request-used", Boolean(earlyRequest.finished));
    }

    return earlyRequestPromise;
  }

  return requestCb();
};